module.exports = __webpack_public_path__ + "img/informacoes.75010c27.svg";